import { Box, CardContent, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import {
  capitalizeFirst,
  formatDigitalTwinFeatureLabel,
  getLatestMeasurementByName,
} from "../../../utils/digitalTwinUtils";

const formatMeasurementValue = (value, type) => {
  const numericValue = Number(value);

  if (value === null || value === undefined || value === "" || Number.isNaN(numericValue)) {
    return "-";
  }
  if (type === "count") return numericValue.toFixed(0);

  return numericValue.toFixed(2);
};

export default function FieldInfosCard({ title, infos }) {
  const RowElement = ({ label, value }) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        py: 1,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", fontWeight: 500 }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.primary", fontWeight: 600 }}
      >
        {value}
      </Typography>
    </Box>
  );

  const getMeasurementInfo = (type) => {
    const info = getLatestMeasurementByName(infos, type);
    return formatMeasurementValue(info?.measurement_value, type);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        ml: 2,
        mr: 2,
        mt: 1,
        mb: 1,
        p: 2,
        backgroundColor: "background.default",
      }}
    >
      <CardContent>
        <Typography variant="body1" sx={{ fontWeight: "bold", pb: 2 }}>
          {title}
        </Typography>
        {infos?.length > 0 && (
          <RowElement
            label={formatDigitalTwinFeatureLabel("name")}
            value={
              `${capitalizeFirst(infos[0]?.plant_type)} ${infos[0]?.plant_number ?? ""}`
            }
          />
        )}
        {infos && (
          <RowElement
            label={formatDigitalTwinFeatureLabel("ndvi")}
            value={getMeasurementInfo("ndvi")}
          />
        )}
        {infos && (
          <RowElement
            label={formatDigitalTwinFeatureLabel("volume")}
            value={getMeasurementInfo("volume")}
          />
        )}
        {infos && (
          <RowElement
            label={formatDigitalTwinFeatureLabel("area")}
            value={getMeasurementInfo("area")}
          />
        )}
        {infos && (
          <RowElement
            label={formatDigitalTwinFeatureLabel("count")}
            value={getMeasurementInfo("count")}
          />
        )}
        {infos && (
          <RowElement
            label={formatDigitalTwinFeatureLabel("height")}
            value={getMeasurementInfo("height")}
          />
        )}
      </CardContent>
    </Card>
  );
}
